import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ScrollTop from "./components/Helper/ScrollTop";
import BackToTop from "./components/Helper/BackToTop";
import Home from './components/Home/index';

function App() {
    return (
        <>
            {/* <Router basename="/name"> */}
            <Router>
                <ScrollTop />
                <Routes>
                    <Route path="/" element={<Home />} />
                </Routes>
                <BackToTop />
            </Router>
        </>
    );
}

export default App;
